<div class="heading">{{title}}</div>

<div fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="fxAlignment"
  [fxLayout.gt-md]="fxDirection">

  <div *ngFor="let entity of items" class="item" fxFlex="flexValue" [ngClass]="direction"
  (click)="goToItem(entity)" style="cursor: pointer;">

    <!-- video -->
    <iframe *ngIf="entity.videourlSafe" [src]="entity.videourlSafe" frameborder="0" allow="fullscreen" allowfullscreen style="width: 100%;"></iframe>

    <!-- image -->
    <div *ngIf="!entity.videourlSafe"
    class="image"
    [style.background-image]="entity.mainImage ? entity.mainImage.safe : ''">
    </div>

    <div class="content">

      <div class="title">
        <span>{{entity.title}}</span>
      </div>
  
      <div fxLayout="row" fxLayoutAlign="end center">
        <button class="transparent-orange-button">Weiterlesen</button>
      </div>
    </div>
    
  </div>
</div>
